import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Eager load main page for best LCP
import Index from "./pages/Index";

// Direct imports for trivial/no-UI components
import DeferredLoader from "./components/DeferredLoader";
import GoogleAnalyticsTracker from "./components/GoogleAnalyticsTracker";
import LazyErrorBoundary from "./components/LazyErrorBoundary";

// Lazy load below-the-fold pages
const LegalNotice = lazy(() => import("./pages/LegalNotice"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const CookiesPolicy = lazy(() => import("./pages/CookiesPolicy"));
const NotFound = lazy(() => import("./pages/NotFound"));
const CookieBanner = lazy(() => import("./components/CookieBanner"));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const App = () => (
  <BrowserRouter>
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/aviso-legal" element={<LegalNotice />} />
        <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
        <Route path="/politica-cookies" element={<CookiesPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <DeferredLoader delay={100}>
        <GoogleAnalyticsTracker />
        <LazyErrorBoundary>
          <Suspense fallback={null}>
            <CookieBanner />
          </Suspense>
        </LazyErrorBoundary>
      </DeferredLoader>
    </Suspense>
  </BrowserRouter>
);

export default App;
